/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'downWhite': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M27.083 38.136l21.055-21.024c1.15-1.223 1.15-3.096 0-4.248-1.15-1.152-3.09-1.152-4.24 0L25 31.8 6.101 12.864c-1.22-1.152-3.09-1.152-4.239 0-1.15 1.152-1.15 3.025 0 4.248l20.982 21.024c1.22 1.152 3.09 1.152 4.24 0z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
